import {
  CONTENT_SEPARATOR,
  DETAILS_CONTENT_KEYS,
  IPlanContent,
  PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
} from '../typings';
import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
  gasKeyDetailsAddons,
} from './common/planDefaults';
import { InternetOfferPerk } from './common/internetOfferPerk';

const PLAN_TONE = 'promote';

export const affinityVariableEPlusContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Affinity Variable ePlus']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: [
          {
            contentKey: DETAILS_CONTENT_KEYS.Rates,
            contentValue: 'Variable',
            modalContent: PlanKeyDetailsModal,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
            contentDescription: 'Variable rates',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.ExitFees,
            contentValue: 'No',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
            contentDescription: 'No exit fees. Leave anytime.',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
            contentValue: '12 months' + CONTENT_SEPARATOR + PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
            contentDescription: '12 month benefit period',
          },
        ],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        gas: gasKeyDetailsAddons,
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    onlineCredits: undefined,
    estimatesDialog: defaultEstimatesDialog(),
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'green',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'green',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
        },
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-affinity-variable-eplus/',
      },
    },
  },
};
